import { SLICE_NAME } from "../../model/types/types";

export const AuthActionType = {
  CHECK_USER_BY_TOKEN: `${SLICE_NAME}/check_user_by_token`,
  LOGIN_BUTTON_CLICKED: `${SLICE_NAME}/login_button_clicked`,
  LOG_OUT_BUTTON_CLICKED: `${SLICE_NAME}/log_out_button_clicked`,
  UPDATE_PROFILE_BUTTON_CLICKED: `${SLICE_NAME}/UPDATE_PROFILE_BUTTON_CLICKED`,
} as const;
